import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../app-state';

@Injectable({ providedIn: 'root' })
export class StateService {
  public state$: Observable<AppState> = this.store;

  public stateSnapshot: AppState;

  constructor(private store: Store<AppState>) {
    this.state$.subscribe((state) => {
      this.stateSnapshot = state;
    });
  }

  dispatch = <TAction extends Action>(action: TAction) => {
    this.store.dispatch(action);
  };

  selectDistinct = <T>(key: string): Observable<T> => this.store.select<T>(key as any);

  clearState() {
    this.store.complete();
  }
}
